module.exports = __webpack_public_path__ + "img/futb-03.2126140f.jpg";